// extracted by mini-css-extract-plugin
module.exports = {"banks-logos":"content_banks-logos__085u5"};